import Navbar from "@/components/site/Navbar";
import ScrollProgress from "@/components/site/ScrollProgress";
import Hero from "@/components/site/Hero";
import Showcase from "@/components/site/Showcase";
import Services from "@/components/site/Services";
import Calculator from "@/components/site/Calculator";
import About from "@/components/site/About";
import References from "@/components/site/References";
import Testimonials from "@/components/site/Testimonials";
import Process from "@/components/site/Process";
import FAQ from "@/components/site/FAQ";
import CtaBand from "@/components/site/CtaBand";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Chatbot from "@/components/site/Chatbot";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative">
      <a href="#inhalt" className="skip-link">
        Zum Inhalt springen
      </a>

      <ScrollProgress />
      <Navbar />

      <main id="inhalt">
        <Hero />
        <Showcase />
        <Services />
        <Calculator />
        <About />
        <References />
        <Testimonials />
        <Process />
        <FAQ />
        <CtaBand />
        <Contact />
      </main>

      <Footer />
      <Chatbot />
    </div>
  );
}
